import React from 'react';
import { Box, Typography, Stack, Chip, IconButton, Link } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const UserList = ({ users, onUserClick, onDeleteClick }) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {users.map((user, index) => (
                <Box
                    key={user.id}
                    onClick={() => onUserClick(user)}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== users.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                >
                    <Box display="flex" justifyContent="space-between">
                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                {user.name}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                {user.email}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#292929',
                                    mt: 2,
                                }}
                            >
                                {user.role}
                            </Typography>
                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                                {user.groups.slice(0, 3).map((group) => (
                                    <Chip
                                        key={group.id}
                                        label={group.name}
                                        size="small"
                                        color="primary"
                                    />
                                ))}
                                {user.groups.length > 3 && (
                                    <Chip
                                        label={`+${user.groups.length - 3}`}
                                        size="small"
                                        color="default"
                                    />
                                )}
                            </Stack>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    color: '#666666',
                                    mt: 2,
                                }}
                            >
                                Último acesso: {user.updated_at}
                            </Typography>
                        </Box>
                        <IconButton>
                            <MenuIcon sx={{ color: '#1F83FF !important' }} />
                        </IconButton>
                        <Link
                            component="button"
                            onClick={(event) => {
                                event.stopPropagation();
                                onDeleteClick(user);
                            }}
                            underline="none"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#1F83FF',
                            }}
                        >
                            <DeleteOutlinedIcon fontSize="small" />
                            <Typography sx={{ ml: 0.5 }}>Excluir</Typography>
                        </Link>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default UserList;
